/** Public site origin for OG tags, WalletConnect metadata, and share previews. */
export const SITE_ORIGIN =
    (typeof process.env.REACT_APP_SITE_URL === 'string' &&
        process.env.REACT_APP_SITE_URL.replace(/^"|"$/g, '').trim().replace(/\/$/, '')) ||
    'https://cronpay.in';

export const OG_IMAGE_URL = `${SITE_ORIGIN}/og-image.png`;
